/**
 * Generated from src/c/src/CODAquaFish.h. That header is the ported canonical
 * AquaFish source, so these are the codes the WASM actually understands -- keep
 * the two in step when re-porting.
 *
 * Note that far fewer of these are implemented than are named: the factory in
 * CODAquaFish.cpp wires the seven feed-table species ORGANIX supports, and any
 * other code falls back to Atlantic salmon.
 */
enum AquaFishModel {
  AQUAFISH                            = 2000,
  AQUAFISHFEEDTABLE                   = 2001,
  AQUAFISHATLANTICSALMON              = 2010,
  AQUAFISHFTATLANTICSALMON            = 2011,
  AQUAFISHZRVATLANTICSALMON           = 2012,
  AQUAFISHFTATLANTICSALMONSCOTLAND    = 2013,
  AQUAFISHRAINBOWTROUT                = 2020,
  AQUAFISHFTRAINBOWTROUT              = 2021,
  AQUAFISHZRVRAINBOWTROUT             = 2022,
  AQUAFISHEUROPEANSEABASS             = 2030,
  AQUAFISHFTEUROPEANSEABASS           = 2031,
  AQUAFISHZRVEUROPEANSEABASS          = 2032,
  AQUAFISHFTEUROPEANSEABASSFRY        = 2033,
  AQUAFISHFTEUROPEANSEABASSBROODSTOCK = 2034,
  AQUAFISHFTASIANSEABASS              = 2040,
  AQUAFISHGILTHEADBREAM               = 2050,
  AQUAFISHFTGILTHEADBREAM             = 2051,
  AQUAFISHFTGILTHEADBREAMHIFCR        = 2052,
  AQUAFISHZRVGILTHEADBREAM            = 2053,
  AQUAFISHTILAPIA                     = 2060,
  AQUAFISHTILAPIAFILTERFEEDER         = 2061,
  AQUAFISHFTNILETILAPIA               = 2062,
  AQUAFISHCOMMONCARP                  = 2070,
  AQUAFISHFTCOMMONCARP                = 2071,
  AQUAFISHFTAMBERJACK                 = 2080,
  AQUAFISHFTAMBERJACKOUT              = 2081,
  AQUAATLANTICSALMON                  = 2500
}

export { AquaFishModel }
